import React from "react";
import ReactTooltip from "react-tooltip";
export var useTooltipEffect = function () {
  React.useEffect(function () {
    ReactTooltip.rebuild();
  });
};